var map = {
	"./apx.svg": 78,
	"./bs.svg": 79,
	"./cordova.svg": 80,
	"./css.svg": 81,
	"./fa.svg": 82,
	"./html.svg": 83,
	"./js.svg": 84,
	"./npm.svg": 85,
	"./sass.svg": 86
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77;